import { useSelector } from 'react-redux'
export const useToken = () => {
  const token = useSelector((state) => state.auth.authData.token)
  const headers = {
    Authorization: `Bearer ${token}`,
  }
  return { headers }
}
